import React, { Component } from 'react';
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import Time from "../../utils/Time";
import {RESERVATION_REQUEST_TIMEOUT_DURATION} from "../../constants/GeneralConstants";
import Countdown from 'react-countdown';
import Money from "../../utils/Money";


export default class ReservationRequestsTableView extends Component {

    static propTypes = {
        reservations: PropTypes.arrayOf(PropTypes.shape({
            reservationRequestId: PropTypes.number.isRequired,
            advertisementId: PropTypes.number.isRequired,
            advertisementTitle: PropTypes.string.isRequired,
            spaceId: PropTypes.number.isRequired,
            spaceTitle: PropTypes.string.isRequired,
            statusId: PropTypes.number.isRequired,
            statusName: PropTypes.string.isRequired,
            startDate: PropTypes.string.isRequired,
            endDate: PropTypes.string.isRequired,
            created: PropTypes.number.isRequired,
            updated: PropTypes.number.isRequired,
            deleted: PropTypes.bool.isRequired,
            pricePerDay: PropTypes.number.isRequired,
            hasOverLappingRequests: PropTypes.bool.isRequired,
        }))
    };

    render() {
        if (this.props.reservations.length === 0) {
            return (
                <div className="text-muted text-center mt-5 mb-5">
                    You currently have no Reservation Requests.
                    <br/>
                    Spruce up your Spaces with more pictures,
                    <br/>
                    or better descriptions to help people,
                    <br/>
                    to help people find them.
                </div>
            );
        }

        return (
            <React.Fragment>
                <div className="d-flex align-content-stretch flex-wrap">
                    {
                        this.props.reservations.map((reservation) => {
                            return (
                                <div className="col-xs-12 col-md-6 col-lg-4 pt-2" key={"Reservation-"+reservation.reservationRequestId}>
                                    <div className="card rounded h-100">
                                        <div className="card-header text-center">
                                            Reservation Request
                                        </div>
                                        <div className="card-body border-top-box pb-1" id={reservation.reservationRequestId}>
                                            <div className="row">
                                                <div className="col-6 border-right">
                                                    <div className="row m-0">
                                                        <h5 className="m-auto">
                                                            Space
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-1 mb-2"/>
                                                    <div className="row m-0">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link pl-0 pr-0 m-auto"
                                                            onClick={(e) => this.handleSpaceClicked(reservation.spaceId)}
                                                        >
                                                            <h6 className="card-title bold-contents-text">
                                                                {reservation.spaceTitle}
                                                            </h6>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="row m-0">
                                                        <h5 className="m-auto">
                                                            Ad
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-1 mb-2"/>
                                                    <div className="row m-0">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link pl-0 pr-0 m-auto"
                                                            onClick={(e) => this.handleAdvertisementClicked(reservation.advertisementId)}
                                                        >
                                                            <h6 className="card-title bold-contents-text">
                                                                {reservation.advertisementTitle}
                                                            </h6>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-12">
                                                    <div className="row justify-content-center">
                                                        <h5>
                                                            Date Range
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-0 mb-2"/>
                                                    <div className="row justify-content-center">
                                                        {this._convertTimestampToStartAndEndString(reservation.startDate, reservation.endDate)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-12">
                                                    <div className="row justify-content-center">
                                                        <h5>
                                                            Total Value
                                                        </h5>
                                                    </div>
                                                    <hr className="mt-0 mb-2"/>
                                                    <div className="row justify-content-center">
                                                        {this._calculatePrice(reservation.pricePerDay, reservation.startDate, reservation.endDate)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer p-0">
                                            <div className="row m-0">
                                                {this._renderResponseButtons(reservation)}
                                            </div>
                                            <div className="row m-0 justify-content-center">
                                                {this._renderCountDown(reservation)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                {this.props.reservations.map((reservation) => this._renderModal(reservation))}
            </React.Fragment>
        );

    }

    _renderCountDown(reservation) {
        if(reservation.statusName !== "PENDING_PAYMENT") {
            return (
                <React.Fragment>
                    <strong className="mr-2">
                        Deadline:
                    </strong>
                    <Countdown
                        date={Time.addTimeToDuration(new Date(reservation.created * 1000), RESERVATION_REQUEST_TIMEOUT_DURATION)}
                        renderer={this._countDownRender}
                    />
                </React.Fragment>

            );
        }
        return (<strong>Pending Payment</strong>);
    }

    _countDownRender({days, hours, minutes, seconds, completed }) {
        if (completed) {
            return (<strong className="text-danger">Time Expired</strong>);
        } else {
            const hoursIncludingDays = (days*24) + hours;
            if (hoursIncludingDays < 24) {
                if (hoursIncludingDays < 1) {
                    return (<span className="text-danger">{hoursIncludingDays}:{minutes}:{seconds}</span>);
                }
                return (<span className="text-warning">{hoursIncludingDays}:{minutes}:{seconds}</span>);
            }
            return (<span>{hoursIncludingDays}:{minutes}:{seconds}</span>);
        }
    }

    _renderResponseButtons(reservation) {
        if(reservation.statusName !== "PENDING_PAYMENT") {
            return (
                <div className="btn-group w-100" role="group" aria-label="Response decision">
                    <button
                        type="button"
                        className="btn btn-success btn-sm"
                        data-toggle="modal"
                        data-target={"#reservation_modal_id_" + reservation.reservationRequestId}
                    >
                        <i className="fas fa-check mr-1" />
                        Accept
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={(e) => this.handleRejectSpaceReservationClicked(reservation.reservationRequestId)}
                    >
                        <i className="fas fa-times mr-1" />
                        Reject
                    </button>
                </div>
            )
        }
        return (<strong className="text-success m-auto">Accepted</strong>);
    }

    _renderModal(reservation) {
        return (
            <div
                className="modal fade"
                id={"reservation_modal_id_" + reservation.reservationRequestId}
                key={"reservation_modal_id_" + reservation.reservationRequestId}
                tabIndex="-1"
                role="dialog"
                aria-labelledby={"reservation_modal_label_" + reservation.reservationRequestId}
                aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id={"modal_label_id_" + reservation.reservationRequestId} >
                                Accept Reservation
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <strong className="mr-2">Advertisement Title:</strong>
                            <span>{reservation.advertisementTitle}</span>
                            <br/>
                            <strong className="mr-2">Dates:</strong>
                            {this._convertTimestampToStartAndEndString(reservation.startDate, reservation.endDate)}
                            <br/>
                            <strong className="mr-2">Value:</strong>
                            {this._calculatePrice(reservation.pricePerDay, reservation.startDate, reservation.endDate)}
                            <br/>
                            {this.renderOverlappingWarning(reservation.hasOverLappingRequests)}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-success" data-dismiss="modal" onClick={(e) => this.handleAcceptSpaceReservationClicked(reservation.reservationRequestId)}>Accept</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderOverlappingWarning(overlapping) {
        if(overlapping) {
            return (
                <div className="col-12 text-center align-self-center mt-sm-3">
                    <div className="alert alert-danger" role="alert">
                        This request start and end date have other overlapping requests. By accepting this request the overlapped requests will be automatically rejected.
                    </div>
                </div>
            )
        }
        return (<div/>);
    }

    handleSpaceClicked = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.RESERVATION_REQUESTS_SPACE_BUTTON_CLICKED, {spaceId: spaceId});
    };

    handleAdvertisementClicked = (advertisementId) => {
        EventPublisher.publish(UIInteractionEvents.RESERVATION_REQUESTS_ADVERTISEMENT_BUTTON_CLICKED, {advertisementId: advertisementId});
    };

    handleRejectSpaceReservationClicked = (reservationRequestId) => {
        EventPublisher.publish(UIInteractionEvents.REJECT_SPACE_RESERVATION_BUTTON_CLICKED, {reservationRequestId: reservationRequestId});
    };

    handleAcceptSpaceReservationClicked = (reservationRequestId) => {
        EventPublisher.publish(UIInteractionEvents.ACCEPT_SPACE_RESERVATION_BUTTON_CLICKED, {reservationRequestId: reservationRequestId});
    };

    _convertTimestampToStartAndEndString(start, end) {
        return Time.parseDate(start).toLocaleDateString() + " to " + Time.parseDate(end).toLocaleDateString();
    }

    _calculatePrice(pricePerDay, startDate, endDate) {
        const numberOfDaysInReservation = Time.calculateDifferenceInDaysBetweenInclusive(Time.parseDate(startDate), Time.parseDate(endDate));
        return Money.formatMoney(pricePerDay * numberOfDaysInReservation);
    }
}

